import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import EndPoints from "../../Api/Endpoints";

export const fetchDeprtmentData = createAsyncThunk(
  "api/department",
  async () => {
    const token = localStorage.getItem("other");
    const response = await fetch(EndPoints.PRISM_GET_DEPARTMENT, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const data = await response.json();
    return data;
  }
);

const departmentSlice = createSlice({
  name: "department",
  initialState: {
    departmentdata: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDeprtmentData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDeprtmentData.fulfilled, (state, action) => {
        state.loading = false;
        state.departmentdata = action.payload?.data || [];
      })
      .addCase(fetchDeprtmentData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default departmentSlice.reducer;